angular.module('TetherApp').factory(
    'emailService',
    [
        '$http',
        function ($http) {
            let randomString = function randomString(length, chars) {
                let result = '';
                for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
                return result;
            };

            let indexEmail = function (page) {
                let uri = '/api/v1/experience/email/' +
                    randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );
                if (page != undefined) {
                    uri += '?page=' + page;
                }
                return $http.get(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let storeEmail = function (data) {
                return $http.post(
                    '/api/v1/experience/email',
                    data,   //OBJECT
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    })
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let updateEmail = function (data) {
                let uri = '/api/v1/experience/email/' + data.experience.eid;
                return $http.put(
                    uri,
                    data,   //OBJECT
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    }
                )
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            let deleteEmail = function (emailId) {
                let uri = '/api/v1/experience/email/' + emailId + '/' +
                    randomString(
                        16,
                        '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
                    );
                return $http.delete(
                    uri,
                    {
                        cache: false,
                        headers: { 'Cache-Control' : 'no-cache' }
                    })
                    .then(
                        function (response) {
                            return response.data;
                        }
                    );
            };

            return {
                indexEmail: indexEmail,
                storeEmail: storeEmail,
                updateEmail: updateEmail,
                deleteEmail: deleteEmail
            }

        }
    ]
);
